export class envParams {
  authUrl?: string;
  authCookie?: string;
  dashboardLiveChatEnabled?: string;
  logoutOpenAmUrl?: string;
  liveChatUrl?: string;
  ga_key?: string;
  liveChatEnabled?: string;
  eventTracing? : string;
}
